// extracted by mini-css-extract-plugin
export default {"wrapper":"Chips_wrapper__WgDnt","chips":"Chips_chips__ImTbx","menu":"Chips_menu__jFQsd","menu__item":"Chips_menu__item__PDitk","ani":"Chips_ani__2EvvT"};